export const formatDateAndTime = (timestamp: string) => {
  const date = new Date(timestamp);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const minutes = date.getMinutes();
  const hours = date.getHours();

  const zero = (num: number) => {
    if (num < 10) {
      return `0${num}`;
    }
    return num;
  };

  return `${zero(day)}.${zero(month)}.${zero(year)} ${zero(hours)}:${zero(minutes)}`;
};

export const formatDateToShortDate = (date: Date, isReversed = false, separator = ".") => {
  const dateParts = date.toLocaleDateString("en-GB").substring(0, 10).split("/");
  if (isReversed) {
    dateParts.reverse();
  }

  return dateParts.join(separator);
};

export const transformDateString = (
  dateString: string,
  currentSeparator = ".",
  separator = "-",
  isReversed = false,
) => {
  if (!dateString) {
    return "";
  }
  const dateParts = dateString.split(currentSeparator);
  if (isReversed) {
    dateParts.reverse();
  }
  return `${dateParts[2]}${separator}${dateParts[1]}${separator}${dateParts[0]}`;
};

export const formatNumberThousandSeparated = (value: number, localization = "de-DE") =>
  Intl.NumberFormat(localization).format(value);

export const getTodayAndAYearAgo = () => {
  const formatDate = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const today = new Date();
  const aYearAgo = new Date();
  aYearAgo.setFullYear(aYearAgo.getFullYear() - 1);

  const formattedToday = formatDate(today);
  const formattedAYearAgo = formatDate(aYearAgo);

  return {
    today: formattedToday,
    aYearAgo: formattedAYearAgo,
  };
};

export const formatLocalizedDateTime = (dateString: string, localization = "de-DE") =>
  Intl.DateTimeFormat(localization, { dateStyle: "long", timeStyle: "short" }).format(
    Date.parse(dateString),
  );
